



















































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeSalasEReservasStore, { Responsavel, RegraReservaSalaTipoEnum, RegraReservaSalaFrequenciaEnum, StatusEnum } from '@/components/Backoffice/Store/BackofficeSalasEReservasStore'
import { onlyNumber, timeout } from '@/utils/common'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import ModalBackofficeRecorrencia from './ModalBackofficeRecorrencia/ModalBackofficeRecorrencia.vue'

@Component({
  components: {
    ModalBackofficeRecorrencia,
  },
})
export default class ModalBackofficeAgendarSala extends Vue {
  @Prop({ default: [] }) cbos: any
  @Prop({ default: [] }) medicos: any
  @Prop({ default: [] }) operadoras: any

  modalHoraInicio: boolean = false
  modalHoraFim: boolean = false
  modalDataInicio: boolean = false
  modalDataFim: boolean = false

  $refs!: {
    modalRoomScheduleBody: HTMLElement,
    regraReservaSalaForm: any,
    dialogHoraInicio: any,
    dialogHoraFim: any,
    dialogDataInicio: any,
    dialogDataFim: any,
  }

  get computedDataInicio() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio
      ? moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).format('DD/MM/YYYY')
      : ''
  }

  get computedDataFim() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataFim
      ? moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataFim).format('DD/MM/YYYY')
      : ''
  }

  get regraReservaSalaFormRules() {
    return {
      valid: true,
      nome: [(v: any) => !!v || 'Campo obrigatório'],
      salaId: [(v: any) => !!v || 'Campo obrigatório'],
      convenios: [],
      especialidades: [(v: any) => this.validateEspecialidades(v)],
      medicos: [(v: any) => this.validateMedicos(v)],
      dataInicio: [(v: any) => !!v || 'Campo obrigatório'],
      dataFim: [(v: any) => !!v || 'Campo obrigatório'],
      horaInicio: [(v: any) => this.validateHoraInicio(v)],
      horaFim: [(v: any) => this.validateHoraFim(v)],
      observacoes: [(v: any) => this.validateObservacoes(v)],
    }
  }

  private horarioRegex = /^([01]\d|2[0-3]):[0-5]\d$/

  validateHoraInicio(v: any) {
    if (['', null, undefined].includes(v)) return 'Campo obrigatório.'
    if (!this.horarioRegex.test(v)) return 'Informe um horário válido (HH:mm).'
    return true
  }

  validateEspecialidades(v: any) {
    if (this.getBackofficeSalasEReservasStore.regraReservaSala.tipo !== 'Bloqueio'
      && this.selectorMedicosEspecialidades === 'Especialidades'
      && (this.getBackofficeSalasEReservasStore.regraReservaSala.convenios && this.getBackofficeSalasEReservasStore.regraReservaSala.convenios.length === 0)
      && v.length === 0
    ) { return 'Campo obrigatório.' }
    return false
  }

  validateMedicos(v: any[]) {
    if (this.getBackofficeSalasEReservasStore.regraReservaSala.tipo !== 'Bloqueio'
      && this.selectorMedicosEspecialidades === 'Medicos'
      && (this.getBackofficeSalasEReservasStore.regraReservaSala.convenios && this.getBackofficeSalasEReservasStore.regraReservaSala.convenios.length === 0)
      && v.length === 0
    ) { return 'Campo obrigatório.' }
    return false
  }

  validateObservacoes(v: any) {
    if (this.getBackofficeSalasEReservasStore.regraReservaSala.tipo === 'Bloqueio' && ['', null, undefined].includes(v)) return 'Campo obrigatório.'
    return false
  }

  validateHoraFim(v: any) {
    if (['', null, undefined].includes(v)) return 'Campo obrigatório.'
    if (!this.horarioRegex.test(v)) return 'Informe um horário válido (HH:mm).'
    const { horaInicio } = this.getBackofficeSalasEReservasStore.regraReservaSala
    if (moment(v, 'HH:mm').isSameOrBefore(moment(horaInicio, 'HH:mm'))) return 'Escolha um horário superior ao de inicio.'
    return true
  }

  normalizeHoraInicio() {
    const value = this.getBackofficeSalasEReservasStore.regraReservaSala.horaInicio
    const normalized = this.normalizeHorario(value)
    if (normalized !== value) this.getBackofficeSalasEReservasStore.setRegraReservaSalaField({ field: 'horaInicio', value: normalized })
  }

  normalizeHoraFim() {
    const value = this.getBackofficeSalasEReservasStore.regraReservaSala.horaFim
    const normalized = this.normalizeHorario(value)
    if (normalized !== value) this.getBackofficeSalasEReservasStore.setRegraReservaSalaField({ field: 'horaFim', value: normalized })
  }

  normalizeHorario(value: string) {
    if (!value) return value
    const parsed = moment(value, ['H:mm', 'HH:mm', 'H:m', 'HH:m'], true)
    return parsed.isValid() ? parsed.format('HH:mm') : value
  }

  get minDate() {
    return new Date().toISOString().substring(0, 10)
  }

  get minDateFim() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio
  }

  get maxDateFim() {
    return moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).add(3, 'years').format('YYYY-MM-DD')
  }

  isNotObject(item: any) {
    return typeof item !== 'object'
  }

  loadingConfirmarRegraReservaSala = false
  loadingApagarOuReativarRegra = false
  apagarOuReativarRegraConfirm = false

  get getBackofficeSalasEReservasStore() {
    return getModule(BackofficeSalasEReservasStore, this.$store)
  }

  get regraReservaSala() { return this.getBackofficeSalasEReservasStore.regraReservaSala }

  get showModalAgendarSala() { return this.getBackofficeSalasEReservasStore.modal.agendarSala }
  set showModalAgendarSala(value: boolean) { this.getBackofficeSalasEReservasStore.setModal({ name: 'agendarSala', value }) }
  get selectorMedicosEspecialidades() { return this.getBackofficeSalasEReservasStore.selectorMedicosEspecialidades }
  set selectorMedicosEspecialidades(value: Responsavel) { this.getBackofficeSalasEReservasStore.setSelectorMedicosEspecialidades(value) }

  changeResponsible(e: Responsavel) {
    this.selectorMedicosEspecialidades = e
    if (e === 'Medicos') this.getBackofficeSalasEReservasStore.setRegraReservaSalaField({ field: 'especialidades', value: [] })
    if (e === 'Especialidades') this.getBackofficeSalasEReservasStore.setRegraReservaSalaField({ field: 'medicos', value: [] })
  }

  changeFrequencia(e: string) {
    switch (e) {
      case RegraReservaSalaFrequenciaEnum.Diario:
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataInicio', value: moment(this.regraReservaSala.recorrencia.dataInicio).format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataFim', value: moment(this.regraReservaSala.recorrencia.dataInicio).add(1, 'years').format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 1 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'semanasDoMes', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: undefined })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: undefined })
        this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
        break
      case RegraReservaSalaFrequenciaEnum.Semanal:
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataInicio', value: moment(this.regraReservaSala.recorrencia.dataInicio).format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataFim', value: moment(this.regraReservaSala.recorrencia.dataInicio).add(1, 'years').format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 1 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).day()] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'semanasDoMes', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: undefined })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: undefined })
        this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
        break
      case RegraReservaSalaFrequenciaEnum.Quinzenal:
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataInicio', value: moment(this.regraReservaSala.recorrencia.dataInicio).format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataFim', value: moment(this.regraReservaSala.recorrencia.dataInicio).add(1, 'years').format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 1 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'semanasDoMes', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: undefined })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: undefined })
        this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
        break
      case RegraReservaSalaFrequenciaEnum.Mensal:
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataInicio', value: moment(this.regraReservaSala.recorrencia.dataInicio).format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataFim', value: moment(this.regraReservaSala.recorrencia.dataInicio).add(1, 'years').format('YYYY-MM-DD') })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 1 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'semanasDoMes', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: 1 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: undefined })
        this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
        break
      // case RegraReservaSalaFrequenciaEnum.Anual:
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataInicio', value: moment(this.regraReservaSala.recorrencia.dataInicio).format('YYYY-MM-DD') })
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'dataFim', value: moment(this.regraReservaSala.recorrencia.dataInicio).add(1, 'years').format('YYYY-MM-DD') })
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 1 })
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [] })
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: undefined })
      //   this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).month() + 1 })
      //   this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
      //   break
      default:
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'intervalo', value: 0 })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDaSemana', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'semanasDoMes', value: [] })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'diaDoMes', value: undefined })
        this.getBackofficeSalasEReservasStore.setRegraReservaSalaRecorrencia({ field: 'mes', value: undefined })
    }
  }

  openModalRecorrencia() {
    this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value: true })
  }

  removeMedico(id: string) {
    this.getBackofficeSalasEReservasStore.removeMedico(id)
  }

  removeEspecialidade(descricao: string) {
    this.getBackofficeSalasEReservasStore.removeEspecialidade(descricao)
  }

  removeOperadora(id: string) {
    this.getBackofficeSalasEReservasStore.removeOperadora(id)
  }

  async confirmarRegraReservaSala() {
    const { mode } = this.getBackofficeSalasEReservasStore
    this.loadingConfirmarRegraReservaSala = true

    if (!this.$refs.regraReservaSalaForm.validate()) {
      this.loadingConfirmarRegraReservaSala = false
      return
    }

    const request = await this.getBackofficeSalasEReservasStore.upsertRegraReserva()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'atualizar'} esta regra ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingConfirmarRegraReservaSala = false
      return
    }

    const avisos = request.data && request.data.avisos ? request.data.avisos : []
    const primeiroAviso = avisos.length ? avisos[0] : ''
    if (primeiroAviso) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${primeiroAviso} ${String.fromCodePoint(0x26A0)}`,
        icon: 'warning',
        color: '#F9A825',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Regra ${mode === 'CREATE' ? 'criada' : 'atualizada'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
    }
    this.loadingConfirmarRegraReservaSala = false
    this.showModalAgendarSala = false
  }

  bloquearSala() {
    this.getBackofficeSalasEReservasStore.setRegraReservaSalaField({
      field: 'tipo',
      value: this.getBackofficeSalasEReservasStore.regraReservaSala.tipo === 'Bloqueio' ? RegraReservaSalaTipoEnum.Preferencial : RegraReservaSalaTipoEnum.Bloqueio,
    })
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  @Watch('showModalAgendarSala')
  async onChangeShowModalAgendarSala(value: boolean) {
    if (!value) {
      this.getBackofficeSalasEReservasStore.clearRegraReservaSala()
      this.$refs.regraReservaSalaForm.resetValidation()
      this.getBackofficeSalasEReservasStore.setSelectorMedicosEspecialidades('Medicos')
      // this.getBackofficeSalasEReservasStore.setRecurrencyDescription('')
      this.loadingApagarOuReativarRegra = false
      this.apagarOuReativarRegraConfirm = false
      this.loadingConfirmarRegraReservaSala = false
      this.getBackofficeSalasEReservasStore.setMode('CREATE')
      this.scrollToTop()
    }
  }

  frequencia: any[] = [
    { text: 'Não se repete', value: 'NaoSeRepete' },
    { text: 'Diário', value: 'Diario' },
    { text: 'Semanal', value: 'Semanal' },
    { text: 'Quinzenal', value: 'Quinzenal' },
    { text: 'Mensal', value: 'Mensal' },
    // { text: 'Anual', value: 'Anual' },
  ]

  meses: any[] = [
    { value: 1, text: 'janeiro' },
    { value: 2, text: 'fevereiro' },
    { value: 3, text: 'março' },
    { value: 4, text: 'abril' },
    { value: 5, text: 'maio' },
    { value: 6, text: 'junho' },
    { value: 7, text: 'julho' },
    { value: 8, text: 'agosto' },
    { value: 9, text: 'setembro' },
    { value: 10, text: 'outubro' },
    { value: 11, text: 'novembro' },
    { value: 12, text: 'dezembro' },
  ]

  async preventIfLessThanOneChecked(e: any) {
    if (!e.target.checked && this.regraReservaSala.recorrencia.diaDaSemana!.length < 1) {
      await timeout(0)
      // @ts-ignore
      this.regraReservaSala.recorrencia.diaDaSemana.push(Number(e.target.value))
    }
  }

  async apagarOuReativarRegra() {
    this.loadingApagarOuReativarRegra = true
    const request = await this.getBackofficeSalasEReservasStore.updateRegraReservaStatus(this.getBackofficeSalasEReservasStore.regraReservaSala.status === 'Removido' ? StatusEnum.Ativo : StatusEnum.Removido)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao apagar esta regra ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingApagarOuReativarRegra = false
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra apagada com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    this.loadingApagarOuReativarRegra = false
    this.showModalAgendarSala = false
  }

  scrollToTop() {
    if (this.$refs.modalRoomScheduleBody) this.$refs.modalRoomScheduleBody.scrollTo(0, 0)
  }
}
